(function () {

  function updateCartCount(count) {
    // Dawn's cart count bubble
    document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
      el.classList.remove('hidden');
      var nums = el.querySelectorAll('[aria-hidden="true"]');
      nums.forEach(function (n) { n.textContent = count; });
      var srs = el.querySelectorAll('.visually-hidden');
      srs.forEach(function (n) { n.textContent = count + ' items'; });
    });
  }

  function handleAddToCart(btn) {
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        return res.json();
      })
      .then(function () {
        btn.textContent = 'Added to cart';
        // Fetch updated cart count
        return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        setTimeout(function () {
          btn.textContent = '+ Cart';
          btn.disabled = false;
        }, 2500);
      })
      .catch(function () {
        btn.textContent = '+ Cart';
        btn.disabled = false;
      });
  }

  function init() {
    document.querySelectorAll('.apex-card__btn--add:not([data-apex-cart-init])').forEach(function (btn) {
      btn.dataset.apexCartInit = '1';
      btn.addEventListener('click', function () { handleAddToCart(btn); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Dawn AJAX re-renders the grid
  new MutationObserver(function () { setTimeout(init, 0); }).observe(
    document.documentElement,
    { childList: true, subtree: true }
  );
})();
